export default {
  methods: {
    buildQuery() {
      var query = {}
      query.billingPeriod = this.$store.state.shared.billingPeriod
      query.projectId = this.$store.state.shared.projectId
      query.siteId = this.$store.state.shared.siteId
      query.userId = this.$store.state.shared.selectedUserId
      query.showClosed = this.$store.state.shared.showClosed
      query.showVoid = this.$store.state.allocations.showVoid
      query.filterBy = this.$store.state.allocations.filterBy
      query.filterCol = this.$store.state.allocations.filterCol
      query.filterDate = this.$store.state.allocations.filterDate
      query.dateRangeStart = this.$store.state.shared.dateRangeStart
      query.dateRangeEnd = this.$store.state.shared.dateRangeEnd
      return query
    }
  }
}
